import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\a\\1\\s\\publicportal\\node_modules\\@ant-design\\nextjs-registry\\es\\AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "D:\\a\\1\\s\\publicportal\\src\\app\\app-provider.tsx");
